import { useContext } from 'react';

import AppContext from "../../../store/app-context";

import './Dialog.scss';

const Dialog = () => {
    const appCtx = useContext(AppContext);

    const confirmAction = () => {
        appCtx.dialog.confirm(null);
        cancelAction();
    };

    const cancelAction = () => {
        appCtx.newDialog({ text: '', confirm: () => {} });
    };

    return (
        <div id="dialog" className={appCtx.dialog.text.length === 0 ? 'hide' : ''}>
            <div className="backdrop" onClick={cancelAction} />
            <div className="modal">
                <div className="modal-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <div className="modal-content">
                    <h3 className="modal-title">Confirm Action</h3>
                    <p className="modal-text">{appCtx.dialog.text}</p>
                </div>
                <div className="modal-actions">
                    <button className="btn-cancel" onClick={cancelAction}>
                        Cancel
                    </button>
                    <button className="btn-confirm" onClick={confirmAction}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Dialog;